<template>
    <div>
        <svg v-if="active" id="wallet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             :width="width"
             :height="height" viewBox="0 0 21.196 28.261">
            <defs>
                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#3266f5"/>
                    <stop offset="1" stop-color="#e21851"/>
                </linearGradient>
                <linearGradient id="linear-gradient-3" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#3266f5"/>
                    <stop offset="1" stop-color="#436ee4"/>
                </linearGradient>
            </defs>
            <path id="Path_6" data-name="Path 6"
                  d="M18.252,27.728H2.944A2.947,2.947,0,0,1,0,24.784V5.944A2.947,2.947,0,0,1,2.944,3H5.3a.589.589,0,0,1,0,1.178H2.944A1.768,1.768,0,0,0,1.178,5.944V24.784a1.768,1.768,0,0,0,1.766,1.766H18.252a1.768,1.768,0,0,0,1.766-1.766V5.944a1.768,1.768,0,0,0-1.766-1.766H15.9A.589.589,0,1,1,15.9,3h2.355A2.947,2.947,0,0,1,21.2,5.944V24.784A2.947,2.947,0,0,1,18.252,27.728Z"
                  transform="translate(0 0.533)" fill="url(#linear-gradient)"/>
            <path id="Path_7" data-name="Path 7"
                  d="M14.009,7.065H5.766A1.768,1.768,0,0,1,4,5.3V2.944a.589.589,0,0,1,.589-.589H7a2.945,2.945,0,0,1,5.77,0h2.414a.589.589,0,0,1,.589.589V5.3A1.768,1.768,0,0,1,14.009,7.065ZM5.178,3.533V5.3a.59.59,0,0,0,.589.589h8.243A.59.59,0,0,0,14.6,5.3V3.533H12.243a.589.589,0,0,1-.589-.589,1.766,1.766,0,1,0-3.533,0,.589.589,0,0,1-.589.589Z"
                  transform="translate(0.71)" fill="url(#linear-gradient)"/>
            <path id="Path_9" data-name="Path 9"
                  d="M16.542,10.178H3.589A.589.589,0,0,1,3.589,9H16.542a.589.589,0,1,1,0,1.178Z"
                  transform="translate(0.533 1.598)" fill="url(#linear-gradient-3)"/>
            <path id="Path_10" data-name="Path 10"
                  d="M16.542,13.178H3.589a.589.589,0,0,1,0-1.178H16.542a.589.589,0,1,1,0,1.178Z"
                  transform="translate(0.533 2.13)" fill="url(#linear-gradient-3)"/>
            <path id="Path_11" data-name="Path 11"
                  d="M16.542,16.178H3.589a.589.589,0,0,1,0-1.178H16.542a.589.589,0,1,1,0,1.178Z"
                  transform="translate(0.533 2.663)" fill="url(#linear-gradient-3)"/>
            <path id="Path_12" data-name="Path 12"
                  d="M16.542,19.178H3.589a.589.589,0,0,1,0-1.178H16.542a.589.589,0,1,1,0,1.178Z"
                  transform="translate(0.533 3.196)" fill="url(#linear-gradient-3)"/>
        </svg>

        <svg v-else id="register" xmlns="http://www.w3.org/2000/svg" width="24.196" height="32.261"
             viewBox="0 0 24.196 32.261">
            <path id="Path_6" data-name="Path 6"
                  d="M20.835,31.228H3.36A3.364,3.364,0,0,1,0,27.868V6.36A3.364,3.364,0,0,1,3.36,3H6.049a.672.672,0,0,1,0,1.344H3.36A2.019,2.019,0,0,0,1.344,6.36V27.868A2.019,2.019,0,0,0,3.36,29.884H20.835a2.019,2.019,0,0,0,2.016-2.016V6.36a2.019,2.019,0,0,0-2.016-2.016H18.147a.672.672,0,0,1,0-1.344h2.688A3.364,3.364,0,0,1,24.2,6.36V27.868A3.364,3.364,0,0,1,20.835,31.228Z"
                  transform="translate(0 1.033)" fill="#3266f5"/>
            <path id="Path_7" data-name="Path 7"
                  d="M15.426,8.065H6.016A2.019,2.019,0,0,1,4,6.049V3.36a.672.672,0,0,1,.672-.672H7.428a3.361,3.361,0,0,1,6.587,0H16.77a.672.672,0,0,1,.672.672V6.049A2.019,2.019,0,0,1,15.426,8.065ZM5.344,4.033V6.049a.673.673,0,0,0,.672.672h9.409a.673.673,0,0,0,.672-.672V4.033H13.409a.672.672,0,0,1-.672-.672,2.016,2.016,0,1,0-4.033,0,.672.672,0,0,1-.672.672Z"
                  transform="translate(1.377)" fill="#3266f5"/>
            <path id="Path_9" data-name="Path 9"
                  d="M18.458,10.344H3.672A.672.672,0,0,1,3.672,9H18.458a.672.672,0,1,1,0,1.344Z"
                  transform="translate(1.033 3.098)" fill="#3266f5"/>
            <path id="Path_10" data-name="Path 10"
                  d="M18.458,13.344H3.672a.672.672,0,0,1,0-1.344H18.458a.672.672,0,1,1,0,1.344Z"
                  transform="translate(1.033 4.13)" fill="#3266f5"/>
            <path id="Path_11" data-name="Path 11"
                  d="M18.458,16.344H3.672a.672.672,0,0,1,0-1.344H18.458a.672.672,0,1,1,0,1.344Z"
                  transform="translate(1.033 5.163)" fill="#3266f5"/>
            <path id="Path_12" data-name="Path 12"
                  d="M18.458,19.344H3.672a.672.672,0,0,1,0-1.344H18.458a.672.672,0,1,1,0,1.344Z"
                  transform="translate(1.033 6.196)" fill="#3266f5"/>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "IWallet",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>
